import { Badge } from 'components/Badge';
import Constants from 'config/Constants';
import { BlockName } from 'pages/documents_v2/views/edit_area/blocks/BlockName';
import { BlockTasks } from 'pages/documents_v2/views/edit_area/blocks/BlockTasks';
import { BlockType } from 'pages/documents_v2/views/edit_area/blocks/BlockType';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BlockActions } from './BlockActions';
import { BlockLabels } from './BlockLabels';

export function BlockToolbar({ block, parentBlock, index, isInsideBlockLayout = false, readOnly = false }) {
    const { t } = useTranslation();
    const { hideChanges } = useContext(EditAreaContext);

    const showActions = useMemo(() => {
        if (readOnly) {
            return false;
        }

        if (parentBlock && parentBlock.properties.type === Constants.blockTypes.textExplanation) {
            return false;
        }

        return true;
    }, [readOnly, parentBlock]);

    const hideLabels = isInsideBlockLayout === true && parentBlock === undefined && readOnly === true;

    return (
        <div className="d-flex justify-content-between position-absolute px-2" style={{ left: 0, right: 0, top: -18 }}>
            <div className="flex-center">
                {block.id && !isInsideBlockLayout && <BlockTasks block={block} />}
                <BlockName block={block} />
            </div>

            <div className="flex-center editor-toolbar">
                {!hideChanges && block.new && (
                    <Badge variant="warning" className="mr-2">
                        {t('documents:document.navbar.main.badges.new')}
                    </Badge>
                )}
                <BlockType block={block} isInsideBlockLayout={isInsideBlockLayout} />

                {!hideLabels && (
                    <BlockLabels block={block} parentBlock={parentBlock} index={index} readOnly={readOnly} />
                )}

                {showActions && <BlockActions block={block} index={index} isInsideBlockLayout={isInsideBlockLayout} />}
            </div>
        </div>
    );
}
